(() => {
  if (window.apCartProtectionReady) return;
  window.apCartProtectionReady = true;

  const showDebug = (toggle, text) => {
    const row = toggle.closest('.ap-cart-protection');
    if (!row) return;
    let msg = row.parentElement.querySelector('#ap-cart-debug');
    if (!msg) {
      msg = document.createElement('div');
      msg.id = 'ap-cart-debug';
      msg.style.cssText = 'margin:8px 0;padding:10px 12px;border-radius:8px;background:#fee2e1;color:#8a1c14;font-size:12px;line-height:1.4;font-family:monospace;white-space:pre-wrap;word-break:break-word;';
      row.after(msg);
    }
    msg.textContent = text;
  };

  const clearDebug = (toggle) => {
    const row = toggle.closest('.ap-cart-protection');
    const msg = row && row.parentElement.querySelector('#ap-cart-debug');
    if (msg) msg.remove();
  };

  const renderDrawer = (state, openDrawer = true) => {
    const sections = state.sections || {};
    const parser = new DOMParser();
    const drawer = document.querySelector('cart-drawer');
    const currentInner = document.querySelector('#CartDrawer .drawer__inner');
    const nextInner = parser.parseFromString(sections['cart-drawer'] || '', 'text/html').querySelector('#CartDrawer .drawer__inner');
    if (!currentInner || !nextInner) throw new Error('La respuesta de Shopify no traía el carrito actualizado (selector .drawer__inner no encontrado).');
    currentInner.innerHTML = nextInner.innerHTML;

    const currentBubble = document.querySelector('#cart-icon-bubble');
    const nextBubble = parser.parseFromString(sections['cart-icon-bubble'] || '', 'text/html').querySelector('#cart-icon-bubble');
    if (currentBubble && nextBubble) currentBubble.innerHTML = nextBubble.innerHTML;
    drawer?.classList.toggle('is-empty', state.item_count === 0);
    if (openDrawer) drawer?.open();
  };

  const requestCart = async (url, body) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const payload = await response.json().catch(() => null);
    if (!response.ok || !payload) {
      const detail = payload && (payload.description || payload.message || JSON.stringify(payload));
      throw new Error(detail || `No se pudo actualizar el carrito (${response.status})`);
    }
    return payload;
  };

  const getBundleConfig = () => {
    const element = document.getElementById('ap-bundle-config');
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (error) { return null; }
  };

  const legacyPropertyNames = ['🚚 Envío incluido', '🛡️ Garantía incluida', '📦 Contenido del pack'];
  let bundleSyncQueue = Promise.resolve();

  const performBundleSync = async ({ render = false, openDrawer = true } = {}) => {
    const config = getBundleConfig();
    if (!config || !Number(config.mainVariantId)) return false;
    let cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((response) => response.json());
    const mainItems = cart.items.filter((item) => Number(item.variant_id) === Number(config.mainVariantId));
    const mainQuantity = mainItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
    let changed = false;

    for (const item of mainItems) {
      const currentProperties = item.properties || {};
      const cleanProperties = { ...currentProperties };
      legacyPropertyNames.forEach((name) => delete cleanProperties[name]);
      if (legacyPropertyNames.some((name) => Object.prototype.hasOwnProperty.call(currentProperties, name))) {
        await requestCart(window.routes.cart_change_url, { id: item.key, quantity: item.quantity, properties: cleanProperties });
        changed = true;
      }
    }

    if (changed) cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((response) => response.json());

    const desired = new Map([
      [Number(config.standardShippingVariantId), mainQuantity === 1 ? 1 : 0],
      [Number(config.priorityShippingVariantId), mainQuantity >= 2 ? 1 : 0],
      [Number(config.warranty6VariantId), mainQuantity === 1 ? 1 : 0],
      [Number(config.warranty12VariantId), mainQuantity >= 2 ? 1 : 0],
      [Number(config.moduleVariantId), mainQuantity >= 2 ? 2 : 0],
      [Number(config.voiceVariantId), mainQuantity >= 2 ? 2 : 0],
    ].filter(([variantId]) => variantId > 0));

    for (const [variantId, desiredQuantity] of desired) {
      const matchingItems = cart.items.filter((item) => Number(item.variant_id) === variantId);
      if (matchingItems.length === 0 && desiredQuantity > 0) {
        await requestCart(window.routes.cart_add_url, { items: [{ id: variantId, quantity: desiredQuantity, properties: { _ap_bundle_gift: 'Sí' } }] });
        changed = true;
        continue;
      }
      for (let index = 0; index < matchingItems.length; index += 1) {
        const item = matchingItems[index];
        const quantity = index === 0 ? desiredQuantity : 0;
        if (Number(item.quantity) !== quantity) {
          await requestCart(window.routes.cart_change_url, { id: item.key, quantity });
          changed = true;
        }
      }
    }

    if (render && changed) {
      const state = await requestCart(window.routes.cart_update_url, {
        updates: {},
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });
      renderDrawer(state, openDrawer);
    }
    return changed;
  };

  window.apSyncAuraPiesGifts = (options = {}) => {
    bundleSyncQueue = bundleSyncQueue.then(() => performBundleSync(options));
    return bundleSyncQueue;
  };

  const scheduleBundleSync = () => {
    window.setTimeout(() => window.apSyncAuraPiesGifts({ render: true, openDrawer: true }).catch((error) => console.error(error)), 180);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'ap-bundle-sync') scheduleBundleSync();
    });
  }

  window.setTimeout(() => window.apSyncAuraPiesGifts({ render: false }).catch((error) => console.error(error)), 0);

  // Only the shipping-protection toggle is handled here. Quantity +/- and
  // remove buttons are left to Dawn's native cart-drawer code (cart.js /
  // cart-drawer.js). Listener runs in the CAPTURE phase so a third-party
  // app script calling stopPropagation() on bubble can't swallow the click
  // before this code runs.
  document.addEventListener('click', async (event) => {
    const checkoutButton = event.target.closest('#CartDrawer-Checkout');
    if (checkoutButton && !checkoutButton.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Preparando tu pedido…';
      try {
        await window.apSyncAuraPiesGifts({ render: false });
        window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
      } catch (error) {
        checkoutButton.disabled = false;
        checkoutButton.textContent = 'Pagar pedido';
        console.error(error);
      }
      return;
    }
    const toggle = event.target.closest('[data-ap-protection-toggle]');
    if (!toggle || toggle.disabled) return;
    clearDebug(toggle);
    toggle.disabled = true;
    toggle.style.opacity = '0.5';
    const active = toggle.getAttribute('aria-pressed') === 'true';
    try {
      let response;
      if (active) {
        response = await fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: toggle.dataset.lineKey, quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
        });
      } else {
        response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: toggle.dataset.variantId, quantity: 1, properties: { _proteccion_envio: 'Sí' } }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
        });
      }
      const payload = await response.json().catch(() => null);
      if (!response.ok) {
        const detail = payload && (payload.description || payload.message || JSON.stringify(payload));
        throw new Error(`Shopify devolvió un error (${response.status}): ${detail || 'sin detalle'}`);
      }
      if (!payload) throw new Error('Shopify respondió sin contenido legible (JSON inválido).');
      renderDrawer(payload);
    } catch (error) {
      toggle.disabled = false;
      toggle.style.opacity = '';
      const text = 'No se pudo actualizar la protección de envío: ' + (error && error.message ? error.message : String(error));
      console.error(text, error);
      showDebug(toggle, text);
    }
  }, true);
})();
